import { render, staticRenderFns } from "./AdminMenuBar.vue?vue&type=template&id=24174e3e&scoped=true"
import script from "./AdminMenuBar.vue?vue&type=script&lang=js"
export * from "./AdminMenuBar.vue?vue&type=script&lang=js"
import style0 from "./AdminMenuBar.vue?vue&type=style&index=0&id=24174e3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24174e3e",
  null
  
)

export default component.exports